module.exports = __webpack_public_path__ + "img/ico-versions.45810869.svg";